import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-oee-state-log',
  templateUrl: './oee-state-log.component.html',
  styleUrls: ['./oee-state-log.component.css']
})
export class OeeStateLogComponent implements OnInit {
    equipmentId;

    public selectedBgOeeStateLogHistory: string = 'A';

    public selectedBgOeeStateLogApprove: string = 'not_confirmed';

    public menu?: Menu;

    public setting?: Setting;

    public itemsListStateLog: Item[] = [];

    public approving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.equipmentId = this.stateService.getStateParams()['equipment_id'];
    }

    private async loadMenu() {
        if (!!this.equipmentId) {
            this.menu = (await this.datatask.Post(239, { equipment_id: this.equipmentId }))[0];
        }
    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(325))[0];
    }

    private async loadStateLog() {
        if (!!this.equipmentId && !!this.selectedBgOeeStateLogHistory && !!this.selectedBgOeeStateLogApprove) {
            this.itemsListStateLog = await this.datatask.Post(257, {
                equipment_id: this.equipmentId,
                mainselector: this.selectedBgOeeStateLogHistory,
                selector: this.selectedBgOeeStateLogApprove
            });
        }
    }

    public async approveChanges() {
        if (!!this.equipmentId) {
            try {
                this.approving = true;

                await this.datatask.Post(258, {
                    oeedata_keyno: '0',
                    equipment_id: this.equipmentId
                });

                this.stateService.back();
            } finally {
                this.approving = false;
            }
        }
    }

    public onTabHistoryChanged() {
        this.loadStateLog();
    }

    public onTabApproveChanged() {
        this.loadStateLog();
    }

    private async init() {
        this.loadMenu();
        this.loadSetting();
        this.loadStateLog();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    equipment_name: string;
}

interface Setting {
    show_approve_all_button: string;
}
